/** the type of aggregations that can be done using the scalars hi endpoint.
 * Different requests need to be sent depending on the type of aggregation.
 */
export enum ScalarsHiAggregation {
  DAY = "day",
  LAST_7_DAYS = "last_7_days",
  LAST_30_days = "last_30_days",
  WEEK = "week",
  MONTH = "month"
}

/** A single slice of the data returned from the scalars hi entry.
 * The amount of data that a slice represents depends on the aggregation method and can be found in the count.  */
export interface ScalarsHiDataSlice {
  count: number;
  date_time: number;
  machine__name: string;
  max: number;
  mean: number;
  min: number;
  site__name: string;
  sum: number;
  tag__name: string;
}

export interface ScalarsHiMedian {
  date_time: string;
  resolution: number;
  values: number[];
}

export interface ScalarsHiMedianResponse {
  tag_name: string;
  site_name: string;
  results: ScalarsHiMedian[];
}

export interface ScalarsHiValuesRange {
  date_time: string;
  resolution: number;
  min: number[];
  max: number[];
}

export interface ScalarsHiValuesRangeResponse {
  tag_name: string;
  site_name: string;
  results: ScalarsHiValuesRange[];
}
